import React from "react";
import PropTypes from "prop-types";

const OscarIcon = ({ className, width, height, fill }) => (
  <svg
    className={className}
    x="0px"
    y="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 61.472 61.472"
  >
    <path
      d="M22.753,47.595c0,1.191,3.575,2.159,7.983,2.159c4.409,0,7.982-0.968,7.982-2.159c0-0.943-2.241-1.743-5.359-2.038
			c0.061-0.37,0.055-0.651,0.055-0.651s-0.672-3.194,0.224-5.046c0.899-1.849,0.562-4.598,0.338-4.99
			c-0.226-0.393-0.504-2.466,0-3.309c0.504-0.841,0.674-2.746,0.952-5.658c0.28-2.913-0.521-3.48-0.521-3.48v-2.408h0.521
			c1.682-0.112,1.906-3.587,2.13-5.156c0.227-1.57,1.348-3.028,0-4.879c-1.345-1.849-4.598-2.523-4.598-2.523l0.057-1.682
			c0,0,0.87-0.729,0.787-3.253C33.217,0,31.101,0,31.101,0h-0.729c0,0-2.116,0-2.2,2.523c-0.084,2.524,0.785,3.253,0.785,3.253
			l0.056,1.681c0,0-3.252,0.673-4.598,2.523s-0.225,3.309,0,4.879c0.226,1.568,0.45,5.043,2.132,5.156h0.522v2.408
			c0,0-0.802,0.568-0.522,3.48c0.279,2.912,0.447,4.817,0.952,5.658c0.504,0.842,0.223,2.915,0,3.31
			c-0.226,0.393-0.562,3.141,0.336,4.99c0.898,1.85,0.225,5.044,0.225,5.044s-0.007,0.283,0.054,0.653
			C24.995,45.854,22.753,46.652,22.753,47.595z"
    />
    <path
      d="M39.757,52.287c0.287-0.357,0.438-0.775,0.425-1.263c-0.049-2.031-0.894-2.475-1.129-2.56
			c-1.977,1.824-7.327,1.936-8.591,1.936c-1.219,0-6.224-0.111-8.353-1.754c-0.337,0.277-0.786,0.917-0.822,2.375
			c-0.011,0.488,0.138,0.904,0.423,1.262c-2.15,0.594-3.479,1.4-3.479,2.286v4.206c0,0,2.466,2.859,13.232,2.69
			C42.229,61.297,43.24,58.02,43.24,58.02v-3.675h-0.043C42.995,53.549,41.718,52.832,39.757,52.287z"
    />
  </svg>
);

export default OscarIcon;
